var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamHoverTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 40,
    viewBox: "0 0 166 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57052 25.1649C4.86197 28.3839 1.56693 34.7277 0 39.5762C24.3994 25.4559 52.734 17.3795 82.9489 17.3795V0C70.8835 7.73169 28.1869 20.6298 7.57052 25.1649Z",
    fill: "url(#paint0_linear_318_5338)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.332 25.1649C161.04 28.3839 164.335 34.7277 165.902 39.5762C141.503 25.4559 113.168 17.3795 82.9531 17.3795V0C95.0185 7.73169 137.72 20.6298 158.336 25.1649H158.332Z",
    fill: "url(#paint1_linear_318_5338)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9484 17.3803V3.27344C82.9484 9.13376 76.6046 12.3393 67.8521 14.3628C43.3543 20.0307 25.5629 24.1763 3.23633 37.7549C26.8925 24.7673 54.0587 17.3803 82.9529 17.3803H82.9484Z",
    fill: "url(#paint2_linear_318_5338)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_5338",
    x1: 0,
    y1: 19.7881,
    x2: 82.9489,
    y2: 19.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_5338",
    x1: 165.902,
    y1: 19.7881,
    x2: 82.9487,
    y2: 19.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_5338",
    x1: 3.23633,
    y1: 20.5142,
    x2: 82.9484,
    y2: 20.5142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E7B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamHoverTop);
export default __webpack_public_path__ + "static/media/team-hover-top.221ff96eed67d60e0dec26ff5fd9dc77.svg";
export { ForwardRef as ReactComponent };